import { Component } from '@angular/core';
import {
  BnaServicesAuthClientModule,
  UserSessionService,
} from 'bna-angular-auth-client';
import { OrganizationDetailsService } from './shared/Services/organization-details.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public appTheme = '';
  title = 'pm-key-automate';

  constructor(
    public userSessionService: UserSessionService,
    private authClient: BnaServicesAuthClientModule,
    private organizationDetails: OrganizationDetailsService
  ) {}

  ngOnInit(): void {
    this.authClient.init();
    this.userSessionService.isAuthenticated$.subscribe((result) => {
      if (!result.isAuthenticated) return;
      this.organizationDetails.setupOrgainzationData();
      let user = this.userSessionService.getProfile();
      this.connectToIntercom(user.email, user.userReferenceId);
    });
  }
  private connectToIntercom(email: string, userReferenceId: string) {
    let config = {
      app_id: environment.intercom.appId,
      email: email,
      user_id: userReferenceId,
      alignment: 'left',
      horizontal_padding: 35,
      vertical_padding: 10,
      api_base: 'https://api-iam.intercom.io',
    };
    window.Intercom('boot', config);
  }
}
